import * as Actions from "./actions";
//-- Reducer -------------------------------------------------------------------------------------------------------------------------------
export default function overviewReportReducer(currState = null, baseAction) {
    let stateChanges;
    switch (baseAction.type) {
        case Actions.FETCHING:
            let fetchingAction = baseAction;
            return {
                isFetching: true,
                agencyId: fetchingAction.agencyId,
                agencyName: null,
                startDate: fetchingAction.fromDate,
                endDate: fetchingAction.toDate,
                items: null,
                totals: {
                    totalListings: 0,
                    totalSaleListings: 0,
                    totalRentalListings: 0,
                    totalViews: 0,
                    totalSaleViews: 0,
                    totalRentalViews: 0,
                    totalOtherViews: 0,
                    totalLeads: 0,
                    totalSaleLeads: 0,
                    totalRentalLeads: 0,
                    totalOtherLeads: 0
                }
            };
        case Actions.LOAD:
            let reportAction = baseAction;
            stateChanges = {
                isFetching: false,
                agencyId: reportAction.report.agencyId,
                agencyName: reportAction.report.agencyName,
                startDate: reportAction.report.startDate,
                endDate: reportAction.report.endDate,
                items: reportAction.report.items,
                totals: reportAction.report.totals
            };
            return stateChanges;
    }
    return currState;
}
